import { sql } from 'drizzle-orm';
import {
  pgTable,
  timestamp,
  varchar,
  text,
  boolean,
  uuid,
  primaryKey,
  uniqueIndex,
} from "drizzle-orm/pg-core";
import { organizations } from './organizations';

// Carriers table
export const carriers = pgTable("carriers", {
  id: uuid("id").primaryKey().default(sql`gen_random_uuid()`),
  name: varchar("name").notNull(),
  code: varchar("code"), // Short code like "STATE_FARM", "ALLSTATE"
  contactEmail: varchar("contact_email"),
  contactPhone: varchar("contact_phone"),
  website: varchar("website"),
  notes: text("notes"),
  isActive: boolean("is_active").default(true),

  // Mailing address (for certified mail via Letterstream)
  mailingAddress: text("mailing_address"),
  mailingCity: varchar("mailing_city"),
  mailingState: varchar("mailing_state"),
  mailingZip: varchar("mailing_zip"),

  // QuickBooks Online Integration
  qboVendorId: varchar("qbo_vendor_id"), // QBO Vendor ID when synced
  qboSyncedAt: timestamp("qbo_synced_at"), // Last successful sync timestamp

  orgId: uuid("org_id").references(() => organizations.id, { onDelete: "cascade" }),

  createdAt: timestamp("created_at").defaultNow(),
  updatedAt: timestamp("updated_at").defaultNow(),
}, (table) => [
  uniqueIndex('carriers_org_id_name_unique').on(table.orgId, table.name),
]);
